import classes from './subMenuTab.scss';

function SubMenuTab(props) {
    const menuData = props.subHeaders.map((subMenu, index) => (
        // <button className={classes.sceBtnOutline} onClick={(e) => props.onMenuItemChange(e, subMenu, index)}> <li className={props.selected === subMenu ? classes.sceSelectedTab : null}><a className={classes.sceTabMenu}>{subMenu}</a></li> </button>
       <li className={props.selected === subMenu ? classes.sceSelectedTab : null}><a aria-label={subMenu} href='javascript:void(0)' className={classes.sceTabMenu} onClick={(e) => props.onMenuItemChange(e, subMenu, index)}>{subMenu}</a></li>
    ));
    return (
        <div className={classes.sceSubMenuSection}>
            <div className={[classes.sceContainerMarginAuto,classes.sceOldMainPadding,props.fromUsageScreen?classes.usageScreenPadding:classes.otherScreenPadding].join(' ')}>
                {/* <p className={classes.sceSubMenuTitle}>{props.header}</p> */}
                <ul className={'list-inline ' + classes.sceSubTab + ''}>
                  {menuData}
                </ul>
            </div>
        </div>
    );
}

export default SubMenuTab;